import { ScreenPropPortLocationItem } from '~/navigation/Navigation.types';

import { PortLocationItem } from './PortLocation.Item';

export const PortLocationItemScreen = (props: ScreenPropPortLocationItem) => {
  return <PortLocationItem id={props.route.params.id} onClose={() => {}} />;
};
